<div class="modal-header">
  <h3>
    {{ ClientRegisteredVendor?.id ? 'Edit' : 'Add' }} ClientRegisteredVendor
  </h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close('cross close')"
  ></button>
</div>
<div class="modal-body">
  @if (ClientRegisteredVendorForm) {
    <form [formGroup]="ClientRegisteredVendorForm">
      <div class="row g-3 align-items-center">
        @if (
          ClientRegisteredVendorForm.get('CompanyComplianceType') &&
          CompanyComplianceTypes.length > 0
        ) {
          <div class="col-4">
            <label class="form-label" requiredAsterisk>Compliance Type</label>
            <select class="form-select" formControlName="CompanyComplianceType">
              <option [value]="undefined" selected disabled>Pick one...</option>
              @for (type of CompanyComplianceTypes; track type) {
                <option [value]="type">
                  {{ type.type }}
                </option>
              }
            </select>
          </div>
        }
        <div class="col-4">
          <label class="form-label">Accounting ID</label>
          <input
            type="text"
            class="form-control"
            formControlName="accountingId"
          />
        </div>
        <div class="col-4">
          <div class="form-check">
            <label for="forceTempActive" class="form-check-label my-0"
              >Force Active?</label
            >
            <input
              id="forceTempActive"
              type="checkbox"
              class="form-check-input"
              formControlName="forceTempActive"
            />
          </div>
        </div>
        <div class="col-4">
          <label
            class="form-label"
            [requiredAsterisk]="
              ClientRegisteredVendorForm.controls.forceTempActive.value
            "
            >Force Active Time</label
          >
          <select class="form-select" formControlName="forceTempActiveTime">
            <option [ngValue]="null" selected disabled>Pick one...</option>
            @for (option of ForceActiveTimeOptions; track option) {
              <option [ngValue]="option">
                {{ option }}
              </option>
            }
          </select>
        </div>
        <div class="col-4">
          <label class="form-label">Requester FirstName</label>
          <input
            type="text"
            class="form-control"
            formControlName="requesterFirstName"
          />
        </div>
        <div class="col-4">
          <label class="form-label">Requester LastName</label>
          <input
            type="text"
            class="form-control"
            formControlName="requesterLastName"
          />
        </div>
        <div class="col-4">
          <label class="form-label" requiredAsterisk>Vendor Legal Name</label>
          <input type="text" class="form-control" formControlName="legalName" />
        </div>
        <div class="col-4">
          <label class="form-label">Vendor DBA</label>
          <input type="text" class="form-control" formControlName="dba" />
        </div>
        <div class="col-4">
          <div class="form-check">
            <label for="forceTempActive" class="form-check-label my-0"
              >Issue 1099?</label
            >
            <input
              id="forceTempActive"
              type="checkbox"
              class="form-check-input"
              formControlName="issue1099"
            />
          </div>
        </div>
        <div class="col-4">
          <label class="form-label" requiredAsterisk>Tax Identification</label>
          <select class="form-select" formControlName="taxIdentification">
            <option [ngValue]="null" selected disabled>Pick one...</option>
            @for (option of TaxIdentificationOptions; track option) {
              <option [ngValue]="option">
                {{ option }}
              </option>
            }
          </select>
        </div>
        @if (
          ClientRegisteredVendorForm.controls['taxIdentification'].value ===
          'EIN'
        ) {
          <div class="col-4">
            <label
              class="form-label"
              [requiredAsterisk]="
                ClientRegisteredVendorForm.controls.taxIdentification.value ===
                'EIN'
              "
              >EIN</label
            >
            <input
              type="text"
              class="form-control"
              placeholder="__-_______"
              [inputMask]="einMask"
              formControlName="ein"
            />
          </div>
        }
        @if (
          ClientRegisteredVendorForm.controls['taxIdentification'].value ===
          'SSN'
        ) {
          <div class="col-4">
            <label
              class="form-label"
              [requiredAsterisk]="
                ClientRegisteredVendorForm.controls.taxIdentification.value ===
                'SSN'
              "
              >SSN</label
            >
            <input
              type="text"
              class="form-control"
              placeholder="___-__-____"
              [inputMask]="ssnMask"
              formControlName="ssn"
            />
          </div>
        }
        <div class="col-4">
          <label class="form-label">Office Phone</label>
          <input
            type="tel"
            class="form-control"
            placeholder="(___)___-____"
            [inputMask]="phoneMask"
            formControlName="phone"
          />
        </div>
        <div class="col-4">
          <label class="form-label">Website</label>
          <input type="text" class="form-control" formControlName="website" />
        </div>
      </div>
      <div class="row">
        <h3>Street Address</h3>
        <hr class="mb-0" />
        <div class="col">
          <app-address-form
            [country]="country"
            [addressForm]="ClientRegisteredVendorForm.controls.StreetAddress"
            [isStreet]="true"
          ></app-address-form>
        </div>
      </div>
      <div class="row">
        <h3>Mailing Address</h3>
        <hr class="mb-0" />
        <div class="col">
          <app-address-form
            [country]="country"
            [addressForm]="ClientRegisteredVendorForm.controls.MailingAddress"
            [isMailing]="true"
          ></app-address-form>
        </div>
      </div>
      @if (ClientRegisteredVendorForm.controls.Contacts.value.length > 0) {
        <form
          [formGroup]="ClientRegisteredVendorForm.controls.Contacts.controls[0]"
          class="row"
        >
          <h3>Contact</h3>
          <hr class="mb-0" />
          <div class="col-6">
            <label for="firstName" class="form-label">First Name</label>
            <input
              type="text"
              class="form-control"
              id="firstName"
              formControlName="firstName"
            />
          </div>
          <div class="col-6">
            <label for="lastName" class="form-label">Last Name</label>
            <input
              type="text"
              class="form-control"
              id="lastName"
              formControlName="lastName"
            />
          </div>
          <div class="col-12">
            <label for="email" class="form-label">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              formControlName="email"
            />
          </div>
          <div class="col-12">
            <label for="phone1" class="form-label">Phone</label>
            <input
              type="tel"
              class="form-control"
              id="phone1"
              placeholder="(___)___-____"
              [inputMask]="phoneMask"
              formControlName="phone1"
            />
          </div>
        </form>
      }
    </form>
  }
</div>
<div class="modal-footer">
  <div class="col-2">
    <button type="button" class="btn btn-danger h-100" (click)="close()">
      Close
    </button>
  </div>

  <div class="col-2">
    <button type="button" class="btn btn-primary h-100" (click)="save()">
      Save
    </button>
  </div>
</div>
